import { useAppSelector } from "../../framework/redux/hooks";

export const useShowWorkShiftEndTimesInMobile = (): boolean => {
    return useAppSelector((state) =>
        state.session.employeeGroupParameters?.showWorkShiftEndTimesInMobile ?? true
    );
};